export const DEFAULT_ICON_URL = `/images/crypto/q.svg`;
